import React from 'react';
import Navbar from '../Navbar/navbar';
import FoodListPage from '../FoodList/foodlist';
import ReminderSection from '../Reminder/reminder';
import ShopList from '../ShopList/shoplist';

const AuthenticatedPage = ({ handleLogout }) => {
  return (
    <div>
      <Navbar handleLogout={handleLogout} />
      <FoodListPage />
    </div>
  );
};
const AuthenticatePage = ({ handleLogout }) => {
    return (
      <div>
        <Navbar handleLogout={handleLogout} />
        <ReminderSection />
      </div>
    );
  };

  const AuthenticatPage = ({ handleLogout }) => {
    return (
      <div>
        <Navbar handleLogout={handleLogout} />
        <ShopList />
      </div>
    );
  };
export {AuthenticatedPage, AuthenticatePage, AuthenticatPage};
